import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';

import { Observable } from 'rxjs';
import { ApiErrorHandler } from 'tridion.web.ui/src/app/angular/api/error/ApiErrorHandler';
import { AuthService } from 'tridion.web.ui/src/app/angular/login/adal/Auth.service';
import { ENVIRONMENT } from 'tridion.web.ui/src/app/angular/environment/ENVIRONMENT';
import { IEnvironment } from '../../../../environment/IEnvironment';

import { TpwService } from '../../../../gdpr/Tpw.service';
import { BaseTPWSampleApi } from './BaseTPWSampleApi';
import { ITpwProductFamily } from '../../../../model/product/tena/tpw/ITpwProductFamily';

@Injectable()
export class TpwProductFamilyApi extends BaseTPWSampleApi<ITpwProductFamily> {
    constructor(
        apiErrorHandler: ApiErrorHandler,
        authService: AuthService,
        @Inject(ENVIRONMENT) environment: IEnvironment,
        http: Http,
        tpwService: TpwService
    ) {
        super(apiErrorHandler, authService, environment, http, tpwService);
    }

    getProductFamily(
        catalogCode: string,
        languageCode: string
    ): Observable<ITpwProductFamily[]> {
        return this.getJson(`?catalogCode=${catalogCode}&languageCode=${languageCode}`);
    }

    protected getBaseUrl() {
        return this.TPWBaseURl + 'SampleOrder/GetProductFamily';
    }
}
